import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

type FlexContainerProps = {
  children: React.ReactNode;
  className?: string;
  component?: React.ElementType;
  variant?: Variants;
};

export type Variants = VariantProps<typeof flexContainerProps>["variant"];

const flexContainerProps = cva("h-full", {
  variants: {
    variant: {
      default:
        "px-3.5 max-w-[64rem] justify-center md:mx-auto md:flex md:space-x-4",
      "col-left": "md:w-1/2 md:px-3.5 md:max-w-[28rem]",
      "col-right": "md:w-1/2 md:pr-3.5 md:max-w-[28rem]",
      aside:
        "pb-[1.875rem] md:w-[43%] pt-8 md:pb-4 md:pt-0 h-auto md:h-full flex flex-col gap-6",
      main: " h-full md:w-[57%] mt-8 md:pb-4 md:mt-0 flex flex-grow flex-col gap-6 self-stretch",
      "full-width":
        "mx-auto w-full max-w-[64rem] space-y-8 pb-5 md:px-8 justify-center",
      "half-width": "px-8 mx-auto w-full my-5 md:w-1/2 max-w-[55rem] space-y-8",
      "main-full-width":
        "md:pb-4 justify-center md:mx-auto md:flex min-h-0 w-full items-stretch min-w-0 max-w-[56rem] px-0 md:flex-row md:gap-10 md:px-5 lg:gap-18.5 lg:px-0",
      "progress-full-width":
        "px-3.5 max-w-[64rem] justify-center md:mx-auto md:flex md:space-x-4 w-full px-3.5 md:block md:space-x-0 md:px-[2.875rem]",
      "cvp-parent":
        "md:pb-4 justify-center md:mx-auto mx-auto flex h-auto max-w-[38rem] flex-col gap-8 px-4 md:max-w-[61rem] md:gap-18.5 md:px-5 lg:px-0",
      "cvp-child": "flex flex-col gap-4 md:flex-row-reverse md:items-start",
      "cvp-main": "mb-11 flex flex-grow flex-col gap-4 md:gap-6",
      "cvp-aside":
        "w-full md:sticky md:top-10 md:max-w-[345px] md:self-start md:shrink-0",
      "status-main":
        "mx-auto mt-20 flex flex-auto flex-col p-4 md:mt-28 md:max-w-[55rem]",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export const FlexContainer = ({
  children,
  className,
  component,
  variant,
}: FlexContainerProps) => {
  const Component = component ?? "div";
  return (
    <Component className={cn(flexContainerProps({ variant, className }))}>
      {children}
    </Component>
  );
};
